module.exports = __webpack_public_path__ + "img/book-meetings.9fe5e835.webp";